import Widget from '../../GridGallery/Widget';

export default Widget;
